// extracted by mini-css-extract-plugin
module.exports = {"container":"Error404_container__3nv2S","principalSection":"Error404_principalSection__3utCn"};